import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	a: 10,
	b: 20,
};

const TestSlice = createSlice({
	name: "testSlice",
	initialState,
	reducers: {
		setTestValues: (state, action) => {
			state.a = state.a + action.payload.a;
			state.b = state.b + action.payload.b;
		},
	},
});

export const { setTestValues } = TestSlice.actions;

export default TestSlice.reducer;
